<template>
  <div id="app">
    <transition enter-active-class="animated fadeIn">
      <router-view v-if="isReload" />
    </transition>
  </div>
</template>

<script>
// import Home from 'views/Home.vue'
// let everypage = {};
export default {
  // components: { Home },
  
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isReload: true,
      // everypage:{}
    };
  },
  components: {
    
  },
  
  created() {
    window.onload = function() {
      document.addEventListener("touchstart", function(event) {
        if (event.touches.length > 1) {
          event.preventDefault();
        }
      });
      document.addEventListener("gesturestart", function(event) {
        event.preventDefault();
      });
      var ip = window.location.host.split(":")[0];
      console.log("ip",ip)
      localStorage.setItem("ip", ip);
      var screenWidth = document.body.clientWidth;    // 屏幕宽
      var screeHeight = document.body.clientHeight ;  // 屏幕高
      localStorage.setItem("screenWidth", screenWidth);
      localStorage.setItem("screeHeight", screeHeight);
      // 判断是否第一次登录
       
      // 获取网络
      var ua = navigator.userAgent;
            var networkStr = ua.match(/NetType\/\w+/) ? ua.match(/NetType\/\w+/)[0] : 'NetType/other';
            networkStr = networkStr.toLowerCase().replace('nettype/', '');
            var networkType
            console.log(networkType)
            switch (networkStr) {
                case 'wifi':
                    networkType = 'wifi';
                    localStorage.setItem("is_wifi", true);
                    localStorage.setItem("network_type", 'wifi');
                    break;
                case '5g':
                    networkType = '5g';
                    localStorage.setItem("is_wifi", false);
                    localStorage.setItem("network_type", '5g');
                    break;
                case '4g':
                    networkType = '4g';
                    localStorage.setItem("is_wifi", false);
                    localStorage.setItem("network_type", '4g');
                    break;
                case '3g':
                    networkType = '3g';
                    localStorage.setItem("is_wifi", false);
                    localStorage.setItem("network_type", '3g');
                    break;
                case '3gnet':
                    networkType = '3g';
                    localStorage.setItem("is_wifi", false);
                    localStorage.setItem("network_type", '3g');
                    break;
                case '2g':
                    networkType = '2g';
                    localStorage.setItem("is_wifi", false);
                    localStorage.setItem("network_type", '2g');
                    break;
                default:
                    networkType = 'other';
                    localStorage.setItem("is_wifi", false);
                    localStorage.setItem("network_type", 'other');
            }
            return networkType;
    };
    console.log("APP");

  },
  methods: {
    reload() {
      this.isReload = false;
      this.$nextTick(() => {
        this.isReload = true;
      });
    },
    

  }
};
</script>

<style>
body {
  margin: 0;
}

.fadeInLeft-enter-active,
.fadeInLeft-leave-active {
  transition: opacity 0.5s;
}

.fadeInLeft-enter,
	.fadeInLeft-leave-to

	/* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
